import { FC } from 'react';
import {
  BrowserRouter,
  Routes,
  Route
} from 'react-router-dom';
import {
  CustomNavigate,
  GlobalModals,
  ThemeSwitch
} from '@app/page-components';
import { AppLayout } from './app/layout';
import { HomeLayout } from './home/layout';

export const RootLayout: FC = () => {
  const wrapperAttributes = location.pathname.startsWith('/home') ? { 'data-home': true } : {};
  return (
    <>
      <BrowserRouter>
        <div id="theme-wrapper" {...wrapperAttributes}>
          <ThemeSwitch />
          <Routes>
            <Route path='/app/*' element={<AppLayout />} />
            <Route path='/home/*' element={<HomeLayout />} />
            {/* Route anything else back to default. */}
            <Route path='/*' element={<CustomNavigate to='/home' />} />
          </Routes>
        </div>
      </BrowserRouter>
      <GlobalModals />
    </>
  );
};
